import { PublicKey } from "@solana/web3.js";

import { MARKETS_API } from "../../constants";
import { AnalyticsInfo } from "./types";

const ANALYTICS_ROUTE = "/analytics";
const USER_WALLET_HEADER = "User-Wallet";

export async function sendTransactionAnalytics<T extends AnalyticsInfo = AnalyticsInfo>(
    user: PublicKey | string,
    metadata: T
) {
    const userWallet = typeof user === "string" ? user : user.toBase58();
    const payload = {
        ...metadata,
        userWallet
    };
    const payloadString = JSON.stringify(payload);
    try {
        await fetch(`${MARKETS_API}${ANALYTICS_ROUTE}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                [USER_WALLET_HEADER]: userWallet
            },
            body: payloadString
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to send transaction analytics", error);
    }
}
